import { getCachedArticleCollection, getCachedThreadCollection, updateArticleResultsCache, } from '#pplx/frontend/apps/ask/hooks/collections-hooks/collection-mutations/cache-helpers.js';
import { useMutateResults } from '#pplx/frontend/apps/ask/providers/ResultsContext.js';
import { useUserInput } from '#pplx/frontend/apps/ask/providers/UserInputProviderShared.js';
import { getArticleByUUIDKey } from '#pplx/frontend/apps/ask/queries/query-keys/articleKeys.js';
import { getArticlesQueryKey, getThreadByUUIDKey, getThreadsQueryKey, } from '#pplx/frontend/apps/ask/queries/query-keys/threadKeys.js';
import { usePathname } from '#pplx/frontend/router/usePathname.js';
import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
export const useCollectionMutationContext = () => {
    const { searchTerm } = useUserInput();
    const queryClient = useQueryClient();
    const route = usePathname();
    const mutateResults = useMutateResults();
    // TODO: find better way to determine which query keys to update
    const THREADS_QUERY_KEY = getThreadsQueryKey({
        search_term: searchTerm ?? '',
    });
    const ARTICLES_QUERY_KEY = getArticlesQueryKey({
        search_term: searchTerm ?? '',
    });
    const isArticleRoute = route?.startsWith('/page') || route?.startsWith('/discover');
    const resultsStore = isArticleRoute ? 'articleResults' : 'results';
    const listItemsKey = isArticleRoute ? ARTICLES_QUERY_KEY : THREADS_QUERY_KEY;
    const fetchByUUIDKey = isArticleRoute ? getArticleByUUIDKey : getThreadByUUIDKey;
    const getCachedCollectionInfo = isArticleRoute
        ? getCachedArticleCollection
        : getCachedThreadCollection;
    const defaultUpdateResultsCache = useCallback((_queryClient, _frontendContextUUID, messageMutator) => {
        mutateResults((oldData) => {
            if (!oldData)
                return oldData;
            // `oldData` is typed `ReadonlyDeep<PerplexityMessage[]>` (proto
            // `collection_info`); `messageMutator` takes
            // `MessageWithPartialCollection` (typespec partial). Cast at both
            // boundaries — input to satisfy the mutator, output to satisfy
            // `mutateResults`'s return type. The structural drift between proto
            // and typespec `Collection` is pre-existing tech debt (#129812).
            const mutated = oldData.map(messageMutator);
            return mutated;
        });
    }, [mutateResults]);
    const updateResultsCache = isArticleRoute ? updateArticleResultsCache : defaultUpdateResultsCache;
    return {
        queryClient,
        searchTerm,
        listItemsKey,
        resultsStore,
        fetchByUUIDKey,
        getCachedCollectionInfo,
        updateResultsCache,
        mutateResults,
    };
};
//# sourceMappingURL=useCollectionMutationContext.js.map